<template>
  <div class="md:px-4 calendar-container">
    <FullCalendar :options="calendarOptions" />
  </div>
</template>
<script setup>
import FullCalendar from '@fullcalendar/vue3';
import { defineProps } from "vue";
defineProps({
  calendarOptions: Object,
  default: () => ({})
});



</script>
<style scoped>
.calendar-container {
  width: 100%;
}

.fc-col-header-cell-cushion {
  font-weight: 400;
  text-align: center;
  padding: 6px 0;
  font-size: 14px;
  font-family: Poppins;
}

.fc-toolbar-title {
  font-weight: 400;
  font-size: 17px !important;
  font-family: Poppins;
}

.fc-button-primary {
  background-color: transparent !important;
  border-color: transparent !important;
  color: var(--gray-600) !important;
  font-size: 17px !important;
}

.fc-timeGridWeek-view .fc-col-header-cell.fc-day-today {
  background-color: var(--teal-50);
}

.fc-timeGridWeek-view .fc-timegrid-col.fc-day-today {
  background-color: var(--teal-50);
}
</style>